import { Card, CardContent } from '@1trading/react';
import { Clock, Server, Tag } from 'lucide-react';
import { StatusChip } from '@/components/ui/status-chip';
import type { AppInfo } from '@/services/api/market-maker';
import { formatDate } from '@/utils/format';
import { PRIMARY_CHIP_CLASS } from './status';

interface AppInfoBarProps {
  info: AppInfo;
}

// Outlined card (primary-tinted border), one horizontal wrap row of chips.
export const AppInfoBar = ({ info }: AppInfoBarProps) => (
  <Card className="border-primary/30">
    <CardContent className="flex flex-wrap items-center gap-6 py-4">
      <StatusChip className={PRIMARY_CHIP_CLASS} icon={Tag}>
        v{info.version}
      </StatusChip>
      <StatusChip icon={Server} variant="info">
        {info.environment}
      </StatusChip>
      <StatusChip icon={Clock} variant="success">
        {info.uptimeHuman}
      </StatusChip>
      <span className="text-sm text-muted-foreground">Started {formatDate(info.startedAt)}</span>
    </CardContent>
  </Card>
);
AppInfoBar.displayName = 'AppInfoBar';
